import { ADMIN_MENU_REQUEST, ADMIN_MENU_SUCCESS, ADMIN_MENU_ERROR,GET_SINGLE_ADMIN_MENU_ERROR,GET_SINGLE_ADMIN_MENU_REQUEST,GET_SINGLE_ADMIN_MENU_SUCCESS } from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case ADMIN_MENU_REQUEST:
            return {
                loading: true,
            };
        case ADMIN_MENU_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case ADMIN_MENU_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}